import { Link } from "react-router-dom";

interface ServiceLink {
  title: string;
  path: string;
}

export const FooterLinkGrid = () => {
  const allServices: Record<string, ServiceLink[]> = {
    'Inbound Voice Agents': [
      { title: 'Customer Service', path: '/services/inbound-voice-agents/customer-service' },
      { title: 'Healthcare Providers', path: '/services/inbound-voice-agents/healthcare-providers' },
      { title: 'Insurance Companies', path: '/services/inbound-voice-agents/insurance-companies' },
      { title: 'Realtor Office', path: '/services/inbound-voice-agents/realtor-office' },
      { title: 'Restaurant Chains', path: '/services/inbound-voice-agents/restaurant-chains' },
      { title: 'SaaS Companies', path: '/services/inbound-voice-agents/saas-companies' }
    ],
    'Outbound Voice Agents': [
      { title: 'Sales Outreach', path: '/services/outbound-voice-agents/sales-outreach' },
      { title: 'Market Research', path: '/services/outbound-voice-agents/market-research' },
      { title: 'Appointment Reminders', path: '/services/outbound-voice-agents/appointment-reminders' },
      { title: 'Debt Collection', path: '/services/outbound-voice-agents/debt-collection' },
      { title: 'Marketing Agency', path: '/services/outbound-voice-agents/marketing-agency' },
      { title: 'Customer Retention', path: '/services/outbound-voice-agents/customer-retention' }
    ],
    'AI Copilots': [
      { title: 'Agent Assistance', path: '/services/ai-copilots/agent-assistance' },
      { title: 'Document Processing', path: '/services/ai-copilots/document-processing' },
      { title: 'Meeting Transcription', path: '/services/ai-copilots/meeting-transcription' },
      { title: 'Email Drafting', path: '/services/ai-copilots/email-drafting' },
      { title: 'Scheduling Optimization', path: '/services/ai-copilots/scheduling-optimization' },
      { title: 'Research Assistance', path: '/services/ai-copilots/research-assistance' }
    ],
    'Automation Services': [
      { title: 'Document Workflow', path: '/services/automation/document-workflow' },
      { title: 'Employee Onboarding', path: '/services/automation/employee-onboarding' },
      { title: 'Inventory Management', path: '/services/automation/inventory-management' },
      { title: 'Customer Communications', path: '/services/automation/customer-communications' },
      { title: 'Process Orchestration', path: '/services/automation/process-orchestration' },
      { title: 'Data Integration', path: '/services/automation/data-integration' }
    ]
  };

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
      {Object.entries(allServices).map(([category, services]) => (
        <div key={category}>
          <h3 className="font-semibold text-foreground mb-4">{category}</h3>
          <ul className="space-y-2">
            {services.map((service, index) => (
              <li key={index}>
                <Link 
                  to={service.path}
                  className="text-muted-foreground hover:text-primary transition-colors text-sm"
                >
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};